<template>
  <!-- <v-card flat tile color="var(--v-appBar-base)"> -->
  <div class="topicCell" :style="isTopicsColumn ? 'background-color: var(--v-appBar-base)':''">
    <v-icon v-if="isTopicsColumn" color="pageHeader" small left
      >mdi-view-agenda</v-icon
    >
    <strong v-if="isTopicsColumn" style="color: var(--v-pageHeader-base)">{{
      agenda
    }}</strong>

    <ul>
      <li
        v-for="(topic, index) in topics"
        :key="index"
        :style="`color:${textColor}; max-width:350px;`"
      >
        {{ topic.topicName }}
        <v-chip style="padding:0 5px;" x-small color="orange darken-3" dark
          >{{ topic.topicCategory || 'not define'}} </v-chip
        >
        <v-chip style="padding:0 5px;margin-left:5px;" x-small color="secondary lighten-2" dark
          >{{ topic.timeInMinutes }} min</v-chip
        >
      </li>
    </ul>
  </div>
</template>
<style scoped>
 .topicCell{
    display: inline-block;
   
 }
</style>
<script>
import customFunctions from "@/codeFiles/taskHelper.js";
export default {
  name: "topicTemplate",
  data: function () {
    return { data: { data: {} } };
  },
  props: {
    isTopicsColumn: Boolean,
  },
  computed: {
    agenda() {
      return this.data.agendaName;
    },
  
    topics() {
      if (this.isTopicsColumn) {
        return this.data.topics;
      } else {
        let meeting = this.data.column.field;
        if (this.data[meeting]) {
          return this.data[meeting].meetingTopics;
        } else {
          return [];
        }
      }
    },
    textColor(){
         if (this.isTopicsColumn) {
        return 'var(--v-secondary-lighten1)';
      } else {
        let meeting = this.data.column.field;
        if (this.data[meeting]) {
          let color = this.data[meeting].meetingType.color;
          return customFunctions.getContrast(color)?'white':'var(--v-secondary-lighten1)';        
        } 
        return 'var(--v-secondary-lighten1)';
      }
    }
  },
  methods: {
    topiclabel(topic) {
      if (topic) {
        return topic.topicText + "(" + topic.timeInMinutes.toString() + ")";
      }
    },
  },
};
</script>